<template>
  <div class="h-full w-full flex flex-col">
        <div class="h-full container mx-auto">
            <div class="px-8 flex flex-col h-full w-full py-8">
                <div class="w-full bg-white rounded-2xl border shadow-lg px-6 md:px-8 py-4 flex flex-col">
                    <div class="flex items-center text-sm font-light">
                        <router-link to="/dashboard" class="opacity-50 hover:opacity-100">Dashboard</router-link>
                        <span class="mx-2">/</span>
                        <router-link to="/training-invitation" class="opacity-50 hover:opacity-100">Training</router-link>
                        <span class="mx-2">/</span>
                        <span>Training Invitation</span>
                    </div>
                    <div class="font-bold">Training Invitation</div>
                </div>
                <section class="mt-8 h-full w-full flex flex-col bg-white rounded-2xl border shadow-lg p-6 md:p-8">
                    <div class="flex flex-col h-full items-center justify-center mt-4" v-if="$apollo.queries.trainingInvitationDetails.loading">
                        <base-spinner></base-spinner>
                    </div>
                    <div v-else-if="!$apollo.queries.trainingInvitationDetails.loading && !hasItem" class="h-full flex justify-center items-center">
                        <h1 class="text-center text-xl font-medium">No invitation found!</h1>
                    </div>
                    <div v-else class="flex flex-col">
                        <div class="flex justify-between flex-wrap">
                            <h1 class="text-base md:text-lg font-semibold capitalize">{{ item.internship.group_name }} - {{ item.internship.ref_no }}</h1>
                        </div>
                        <div class="flex flex-row flex-wrap mt-4">
                            <div class="w-1/4 font-medium">Reference Number</div>
                            <div class="w-3/4">{{ item.internship.ref_no }}</div>
                        </div>
                        <div class="flex flex-row flex-wrap mt-2">
                            <div class="w-1/4 font-medium">Name of Group</div>
                            <div class="w-3/4">{{ item.internship.group_name }}</div>
                        </div>
                        <div class="flex flex-row flex-wrap mt-2">
                            <div class="w-1/4 font-medium">Training Entity</div>
                            <div class="w-3/4">{{ item.internship.partner.en_company_name }}</div>
                        </div>
                        <div class="flex flex-row flex-wrap mt-2">
                            <div class="w-1/4 font-medium">Location</div>
                            <div class="w-3/4">{{ item.internship.location }}</div>
                        </div>
                        <div class="flex flex-row flex-wrap mt-2">
                            <div class="w-1/4 font-medium">Specialization</div>
                            <div class="w-3/4">{{ item.internship.field_of_training }}</div>
                        </div>
                        <div class="flex flex-row flex-wrap mt-2">
                            <div class="w-1/4 font-medium">Supervisor</div>
                            <div class="w-3/4">{{ item.internship.supervisor }}</div>
                        </div>
                        <div class="flex flex-row flex-wrap mt-2">
                            <div class="w-1/4 font-medium">Start Date</div>
                            <div class="w-3/4">{{ getDate(item.internship.start_date) }}</div>
                        </div>
                        <div class="flex flex-row flex-wrap mt-2">
                            <div class="w-1/4 font-medium">End Date</div>
                            <div class="w-3/4">{{ getDate(item.internship.end_date) }}</div>
                        </div>
                        <div v-if="!isStatusUpdated" class="w-full flex justify-center mt-6">
                            <div @click.stop="updateTrainingInvitation(false)" class="flex justify-center items-center bg-red-600 hover:bg-white border-red-600 border px-4 py-2 rounded-lg cursor-pointer text-white hover:text-red-600 mr-2">Reject</div>
                            <div @click.stop="updateTrainingInvitation(true)" class="flex justify-center items-center bg-white hover:bg-green-600 border-green-600 border px-4 py-2 rounded-lg cursor-pointer text-green-600 hover:text-white ml-2">Accept</div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
        <div class="h-full flex justify-center items-center" v-if="isLoading">
            <base-page-spinner type="spin" class-list="h-20"></base-page-spinner>
        </div>
    </div>
</template>

<script>
import gql from 'graphql-tag';
import { formattedDate } from "../../helpers/utils";
export default {
    name: "training-invitation-details",
    props: ["token"],
    data() {
        return {
            trainingInvitationDetails: [],
            isLoading: false,
        };
    },
    computed: {
        item() {
            return this.trainingInvitationDetails.internship_candidate;
        },
        hasItem() {
            if (this.item) {
                return true;
            } else {
                return false;
            }
        },
        isStatusUpdated() {
            if (this.item.status === null) {
                return false;
            } else {
                return true;
            }
        },
    },
    apollo: {
        trainingInvitationDetails () {
            return {
                query: gql`query GetTrainingInvitationDetails($token: String!) {
                    trainingInvitationDetails(token: $token) {
                        error
                        error_code
                        message
                        internship_candidate {
                            token
                            status
                            internship {
                                ref_no
                                token
                                group_name
                                partner {
                                    en_company_name
                                }
                                location
                                field_of_training
                                start_date
                                end_date
                                supervisor
                            }
                        }
                    }
                }`,
                variables () {
                    return {
                        token: this.token,
                    }
                },
                fetchPolicy: 'cache-and-network'
            }
        },
    },
    methods: {
        getDate(date) {
            return formattedDate(date);
        },
        showToast(message = '') {
            this.$apollo.queries.trainingInvitationDetails.refetch();
            const Toast = this.$swal.mixin({
                toast: true,
                position: 'top-end',
                showConfirmButton: false,
                timer: 1000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener('mouseenter', this.$swal.stopTimer)
                    toast.addEventListener('mouseleave', this.$swal.resumeTimer)
                }
            })
            Toast.fire({
                icon: 'success',
                title: message
            })
        },
        async updateTrainingInvitation(status) {

            const UPDATE_MUTATION = gql`
                mutation updateTrainingInvitation($token: String!, $status: Boolean!) {
                    updateTrainingInvitation(token: $token, status: $status) {
                        error
                        message
                    }
                }
            `;

            this.isLoading = true;
            let error = null;
            let success = null;

            try {
                await this.$apollo.mutate({
                    mutation: UPDATE_MUTATION,
                    variables: {
                        token: this.token,
                        status: status,
                    }
                }).then((data) => {
                    if (data.data.updateTrainingInvitation.error) {
                        error = data.data.updateTrainingInvitation.message;
                    } else {
                        success = data.data.updateTrainingInvitation.message;
                    }
                }).catch((err) => {
                    error = err;
                })

            } catch (err) {
                error = err.message || "Failed to authenticate, try later.";
            }

            this.isLoading = false;

            if (error === null) {
                this.showToast(success);
            } else {
                this.$swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: error,
                }).then((result) => {
                    if (result.value || result.dismiss) {
                        this.isLoading = false;
                    }
                })
            }
        }
    },
}
</script>